"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify-icon/react";

import { Badge } from "@/components/ui/badge";
import useUserStore from "@/features/auth/store/useUserStore";

export const DashboardHeader = () => {
  const { t } = useTranslation(["workspaces", "common"]);
  const { user } = useUserStore();

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return t("workspaces:dashboard.goodMorning");
    if (hour < 17) return t("workspaces:dashboard.goodAfternoon");

    return t("workspaces:dashboard.goodEvening");
  };

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className="bg-side-accent/50 text-accent-foreground relative mb-6 overflow-hidden rounded-2xl border-none p-4 sm:mb-8 sm:p-6"
      initial={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.4 }}
    >
      <div className="absolute inset-0 opacity-5">
        <div className="absolute -top-20 -right-20 h-40 w-40 rounded-full bg-gradient-to-br from-blue-400 to-purple-600" />
        <div className="absolute -bottom-16 -left-16 h-32 w-32 rounded-full bg-gradient-to-tr from-green-400 to-blue-500" />
      </div>

      <div className="relative">
        <div className="flex items-start justify-between">
          <div className="flex w-full flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
            <motion.div
              animate={{ scale: 1 }}
              className="bg-muted/20 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl backdrop-blur-sm max-sm:hidden sm:h-14 sm:w-14 sm:rounded-2xl"
              initial={{ scale: 0.8 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              <Icon
                className="text-accent-foreground"
                height="1.5rem"
                icon="mdi:view-dashboard-outline"
                width="1.5rem"
              />
            </motion.div>
            <div className="w-full">
              <h1 className="text-accent-foreground text-2xl leading-tight font-bold sm:text-3xl">
                {getGreeting() as string}, {user?.firstName || t("common:user")}!
              </h1>
              <div className="bg-muted/20 mt-2 flex w-full flex-col gap-2 rounded-xl p-3 backdrop-blur-xl sm:mt-3 sm:gap-3">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
                  <p className="text-muted-foreground text-sm sm:text-base">
                    {t("workspaces:dashboard.findTutorMarketplace")}
                  </p>
                  <Badge
                    className="bg-muted/30 text-muted-foreground w-fit gap-1 border-white/20"
                    variant="outline"
                  >
                    <Icon height="0.75rem" icon="mdi:clock" width="0.75rem" />
                    {t("common:soon")}
                  </Badge>
                </div>
                <p className="text-muted-foreground text-xs sm:text-sm">
                  {t("workspaces:dashboard.inviteOnlyInfo")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
